// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"CustomControl__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CustomControl/CustomControl.scss
 ** module id = 908
 ** module chunks = 1
 **/